import { render } from "./MissionGame.vue?vue&type=template&id=c166ff48&scoped=true"
import script from "./MissionGame.vue?vue&type=script&lang=js"
export * from "./MissionGame.vue?vue&type=script&lang=js"

import "./MissionGame.vue?vue&type=style&index=0&id=c166ff48&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c166ff48"]])

export default __exports__